import React, { useEffect, useState, useLayoutEffect } from 'react';
import {
  useSearchParams,
} from "react-router-dom";
import { Navigate } from 'react-router-dom';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import TR from './../../Trans';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Capacitor } from '@capacitor/core';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { ReactComponent as MuvikaSongbookLogo } from './../../assets/songbook.svg';
import { ReactComponent as MuvikaSongbookLogoInv } from './../../assets/songbook-inv.svg';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Waiting from '../items/Waiting';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Avatar from '@mui/material/Avatar';
import ErrorDialog from '../dialogs/ErrorDialog';
import { useLocalStorage } from '../../services/useLocalStorage';
import CssBaseline from '@mui/material/CssBaseline';
import SongbookApp from './SongbookApp';
import TermsDialog from '../dialogs/TermsDialog';
import Error from './../items/Error';
import ChooseLanguage from './../items/ChooseLanguage';
import captchaStore from '../../stores/captcha';
import Message from './../items/Message';
import Container from '@mui/material/Container';
import MuvikaService from './../../services/muvika';
import messageStore from '../../stores/message';
import songbookSessionStore from './../../stores/songbookSession';
import environmentStore from './../../stores/environment';
import muvikaAttrs from './../../attrs';
import ThemeToggleButton from '../items/ThemeToggleButton';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

const sessionCloseErrorCode = 2004;
const tooFewPrivileges = 2009;

function SongbookLogin() {

  const [queryParameters] = useSearchParams();

  const isLoggedIn = songbookSessionStore((state) => state.isLoggedIn);
  const isGettingCaptcha = captchaStore((state) => state.isGettingCaptcha);
  const currentError = messageStore((state) => state.currentError);
  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const updateSession = songbookSessionStore((state) => state.updateSession);
  const isSessionOpen = songbookSessionStore((state) => state.isSessionOpen);
  const isSessionOpening = songbookSessionStore((state) => state.isSessionOpening);
  const openSession = songbookSessionStore((state) => state.openSession);
  const setError = messageStore((state) => state.setError);
  const login = songbookSessionStore((state) => state.login);
  const clearError = messageStore((state) => state.clearError);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const logout = songbookSessionStore((state) => state.logout);
  const isLoginSeqError = songbookSessionStore((state) => state.isLoginSeqError);
  const isWaiting = songbookSessionStore((state) => state.isWaiting);
  const environment = environmentStore((state) => state.environment);
  const setNormalMode = songbookSessionStore((state) => state.setNormalMode);
  const setPublicMode = songbookSessionStore((state) => state.setPublicMode);
  const setBoothMode = songbookSessionStore((state) => state.setBoothMode);
  const captchaId = captchaStore((state) => state.captchaId);
  const captchaData = captchaStore((state) => state.captchaData);
  const createCaptcha = captchaStore((state) => state.createCaptcha);
  const logoutChange = songbookSessionStore((state) => state.logoutChange);

  const [errorDialogOpen, setDialogErrorOpen] = useState(true);
  const [isRendered, setRendered] = useState(false);

  const [captchaCode, setCaptchaCode] = useState('');
  const [isCaptchaTryingAgain, setIsCaptchaTryingAgain] = useState(false);

  const handleDialogErrorClose = (event, reason) => {
    setDialogErrorOpen(false);
  };

  const handleDialogClose = (event, reason) => {
    setDialogErrorOpen(false);
  };

  const [songbookId, setSongbookId] = useState(() => {
    let songbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
    let param = queryParameters.get("songbook_code");
    console.log("songbook state", param, songbookCode);
    if (param) {
      return param;
    } else if (songbookCode) {
      return songbookCode;
    }
  });
  const [, updateState] = useState();

  const [isPrivacyDialogOpen, setIsPrivacyDialogOpen] = useState(false);

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem(muvikaAttrs.service + "-session-language");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  const handleOpenPrivacyDialog = () => {
    setIsPrivacyDialogOpen(true);
  };

  const handleClosePrivacyDialog = () => {
    setIsPrivacyDialogOpen(false);
  };

  const handleLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    TR.setLanguage(lowLang);
    document.title = TR.ww_page_title;
    localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(lowLang));
    updateSession(sessionToken, lowLang);
    getEnvironment(sessionToken);
    updateState({});
  };

  const checkAfterSessionEnd = () => {
    let isPublicMode = localStorage.getItem(muvikaAttrs.service + "-songbook-public-mode");
    if (isPublicMode) isPublicMode = JSON.parse(isPublicMode);
    let isBoothMode = localStorage.getItem(muvikaAttrs.service + "-songbook-booth-mode");
    if (isBoothMode) isBoothMode = JSON.parse(isBoothMode);
    let songbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
    var href = window.location.href;
    let hrefSplitted = href.split("?");
    if (hrefSplitted.length > 1) {
      href = hrefSplitted[0];
    }
    if (isPublicMode) {
      console.log("songbookcheck", isPublicMode, isBoothMode);
      window.location.replace(href + "?public_mode=1&songbook_code=" + songbookCode);
    } else if (isBoothMode) {
      window.location.replace(href + "?booth_mode=1&songbook_code=" + songbookCode);
    }
  };

  const resetAndLogout = () => {
    localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
    localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
    localStorage.removeItem(muvikaAttrs.service + "-songbook-songbook-code");
    logout();
  };

  const checkParameters = (isPublicMode, isBoothMode, isNormalMode, songbookCode) => {
    var href = window.location.href;
    let hrefSplitted = href.split("?");
    if (hrefSplitted.length > 1) {
      href = hrefSplitted[0];
    }
    if (isSessionOpen) {
      if (isLoggedIn) {
        console.log("songbook", isPublicMode, isBoothMode, isNormalMode, songbookCode);
        let earlierSongbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
        if (songbookCode && earlierSongbookCode !== songbookCode && (isPublicMode == 1 || isBoothMode == 1)) {
          logoutRedirect(songbookCode, isPublicMode, isBoothMode);
        } else {
          if (isPublicMode == 1 && earlierSongbookCode) {
            localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
            localStorage.setItem(muvikaAttrs.service + "-songbook-public-mode", true);
            //localStorage.setItem(muvikaAttrs.service+"-songbook-songbook-code", songbookCode);
            setPublicMode();
          } else if (isBoothMode == 1 && earlierSongbookCode) {
            localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
            localStorage.setItem(muvikaAttrs.service + "-songbook-booth-mode", true);
            //localStorage.setItem(muvikaAttrs.service+"-songbook-songbook-code", songbookCode);
            setBoothMode();
          } else if (isPublicMode == 0) {
            resetAndLogout();
          } else if (isBoothMode == 0) {
            resetAndLogout();
          } else if (isNormalMode == 1) {
            localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
            localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
            //localStorage.removeItem(muvikaAttrs.service+"-songbook-songbook-code");
            setNormalMode();
          }
        }
      }
    }
    //window.history.pushState('object', document.title, href);
  };

  useEffect(() => {
    console.log("songbook check parameters");
    let isPublicMode = queryParameters.get("public_mode");
    let isBoothMode = queryParameters.get("booth_mode");
    let isNormalMode = queryParameters.get("normal_mode");
    let songbookCode = queryParameters.get("songbook_code");
    if (isPublicMode === "") {
      console.log("songbook");
      isPublicMode = 1;
    }
    if (isBoothMode === "") {
      isBoothMode = 1;
    }
    if (isNormalMode === "") {
      isNormalMode = 1;
    }
    console.log("songbookmode", isPublicMode, isBoothMode, isNormalMode, songbookCode);
    if (language.length > 0) {
      handleLanguageChange(language);
    }
    if (queryParameters && isSessionOpen && isLoggedIn) {
      let isPublicMode = queryParameters.get("public_mode");
      let isBoothMode = queryParameters.get("booth_mode");
      let isNormalMode = queryParameters.get("normal_mode");
      let songbookCode = queryParameters.get("songbook_code");
      if (isPublicMode === "") {
        isPublicMode = 1;
      }
      if (isBoothMode === "") {
        isBoothMode = 1;
      }
      if (isNormalMode === "") {
        isNormalMode = 1;
      }
      console.log("songbookmode", isPublicMode, isBoothMode, isNormalMode, songbookCode);
      checkParameters(isPublicMode, isBoothMode, isNormalMode, songbookCode);
      setRendered(false);
    }
    if (!isSessionOpen && !isSessionOpening) {
      openSession(language.length > 0 ? language.toLowerCase() : "english");
    }
    if (!isGettingCaptcha && isSessionOpen && !captchaId && !captchaData) {
      createCaptcha(songbookSessionStore.getState().sessionToken);
    }
    clearError();
  }, [queryParameters]);


  useEffect(() => {
    if (isLoggedIn) {
      let songbookCode = queryParameters.get("songbook_code");
      if (!songbookCode) {
        setSongbookId("");
      }
    } else {
      if (!isGettingCaptcha && isSessionOpen && !captchaId && !captchaData) {
        createCaptcha(songbookSessionStore.getState().sessionToken);
      }
    }
  }, [isLoggedIn]);

  useEffect(() => {
    console.log("captcha", captchaData);
    if (captchaData) {
      setCaptchaCode('');
      setIsCaptchaTryingAgain(true);
    }
  }, [captchaData]);

  useEffect(() => {
    if (!environment && isSessionOpen) {
      getEnvironment(sessionToken);
    }
    if (isSessionOpen && !isLoggedIn && isRendered) {
      checkAfterSessionEnd();
      setRendered(false);
    }
    if (!isGettingCaptcha && isSessionOpen && !captchaId && !captchaData) {
      createCaptcha(songbookSessionStore.getState().sessionToken);
    }
  }, [sessionToken]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      let isPublicMode = queryParameters.get("public_mode");
      let isBoothMode = queryParameters.get("booth_mode");
      let songbookCode = queryParameters.get("songbook_code");
      if (isPublicMode === "") {
        isPublicMode = 1;
      }
      if (isBoothMode === "") {
        isBoothMode = 1;
      }
      if ((isPublicMode == 1 || isBoothMode == 1) && songbookCode) {
        loginAndRedirect(songbookCode, captchaId, captchaCode, isPublicMode == 1, isBoothMode == 1);
      } else {
        checkAndLogin(songbookId, captchaId, captchaCode, false, false);
      }
    }
  };

  const renderSongbookCodeInput = (songbookCode) => {
    console.log("songbook " + songbookId);
    return <Box>
      <InputLabel>{TR.cm_songbook_id}</InputLabel>
      <TextField
        margin="normal"
        size="small"
        required
        fullWidth
        value={songbookId}
        onChange={(e) => setSongbookId(e.target.value.toLowerCase())}
        autoFocus={songbookId ? songbookId.length == 0 : true}
      />
    </Box>;
  };

  const renderCaptcha = () => {
    console.log("captcha", captchaId, captchaData);
    if (captchaId && captchaData) {
      return <Box>
        <InputLabel>{TR.cm_enter_captcha_code}</InputLabel>
        <Stack direction="row" spacing={2}>
          <img src={captchaData} />
          <TextField
            id="muvika-register-captcha"
            margin="normal"
            size="small"
            required
            fullWidth
            value={captchaCode}
            autoFocus={songbookId ? songbookId.length > 0 : false}
            onChange={(e) => setCaptchaCode(e.target.value.toLowerCase())}
          />
        </Stack>
      </Box>;
    }
  };

  const checkAndLogin = (songbookCode, captchaId, captchaCode, isPublicMode, isBoothMode) => {
    if (captchaCode.length > 0) {
      localStorage.setItem(muvikaAttrs.service + "-songbook-public-mode", isPublicMode == 1);
      localStorage.setItem(muvikaAttrs.service + "-songbook-booth-mode", isBoothMode == 1);
      localStorage.setItem(muvikaAttrs.service + "-songbook-songbook-code", songbookCode);
      login(songbookCode, captchaId, captchaCode, isPublicMode == 1, isBoothMode == 1);
      var href = window.location.href;
      let hrefSplitted = href.split("?");
      if (hrefSplitted.length > 1) {
        href = hrefSplitted[0];
      }
      window.history.pushState('object', document.title, href);
    } else {
      setError(sessionToken, 0, TR.cm_invalid_captcha_code);
    }
  };

  const loginAndRedirect = (songbookCode, captchaId, captchaCode, isPublicMode, isBoothMode) => {
    if (captchaCode.length > 0) {
      localStorage.setItem(muvikaAttrs.service + "-songbook-public-mode", isPublicMode == 1);
      localStorage.setItem(muvikaAttrs.service + "-songbook-booth-mode", isBoothMode == 1);
      localStorage.setItem(muvikaAttrs.service + "-songbook-songbook-code", songbookCode);
      login(songbookCode, captchaId, captchaCode, isPublicMode == 1, isBoothMode == 1);
      var href = window.location.href;
      let hrefSplitted = href.split("?");
      if (hrefSplitted.length > 1) {
        href = hrefSplitted[0];
      }
      window.history.pushState('object', document.title, href);
    } else {
      setError(sessionToken, 0, TR.cm_invalid_captcha_code);
    }
  };

  const logoutRedirect = (songbookCode, isPublicMode, isBoothMode) => {
    localStorage.setItem(muvikaAttrs.service + "-songbook-public-mode", isPublicMode == 1);
    localStorage.setItem(muvikaAttrs.service + "-songbook-booth-mode", isBoothMode == 1);
    localStorage.setItem(muvikaAttrs.service + "-songbook-songbook-code", songbookCode);
    logoutChange(songbookCode, isPublicMode == 1, isBoothMode == 1);
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-songbook-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaSongbookLogo className="muvika-logo-songbook-svg" />
    } else {
      return <MuvikaSongbookLogoInv className="muvika-logo-songbook-svg" />
    }
  };

  const renderPublicBoothMode = (isPublicMode, isBoothMode, songbookCode) => {
    return <Box
      className="muvika-entry-box"
    >
      <TermsDialog
        open={isPrivacyDialogOpen}
        onClose={handleClosePrivacyDialog}
        title={TR.cm_register_clause}
        url={environment ? environment.urls.url_privacy_home : ""}
      />
      <ChooseLanguage isSongbook={true} environment={environment} onLanguageChange={handleLanguageChange} />
      <p>
        {renderLogo()}
      </p>
      <Box noValidate sx={{ mt: 1 }}>
        {renderCaptcha()}
        <Button
          onClick={() => loginAndRedirect(songbookCode, captchaId, captchaCode, isPublicMode == 1, isBoothMode == 1)}
          fullWidth
          variant="text"
          color="success"
          sx={{ mt: 3, mb: 2 }}
        >
          {TR.cm_log_in}
        </Button>
      </Box>
    </Box>;
  };

  const renderNormalMode = (songbookCode) => {
    return <Box
      className="muvika-entry-box"
    >
      <TermsDialog
        open={isPrivacyDialogOpen}
        onClose={handleClosePrivacyDialog}
        title={TR.cm_register_clause}
        url={environment ? environment.urls.url_privacy_home : ""}
      />
      <ChooseLanguage isSongbook={true} environment={environment} onLanguageChange={handleLanguageChange} />
      <p>
        {renderLogo()}
      </p>
      <Box noValidate sx={{ mt: 1 }}>
        {renderSongbookCodeInput(songbookCode)}
        {renderCaptcha()}
        <Button
          onClick={() => checkAndLogin(songbookId, captchaId, captchaCode, false, false)}
          fullWidth
          variant="text"
          color="success"
          sx={{ mt: 3, mb: 2 }}
        >
          {TR.cm_log_in}
        </Button>
        <p style={{ textAlign: "center" }}>
          <ThemeToggleButton isSongbook={true} />
        </p>
      </Box>
    </Box>;
  };

  const renderIfSessionOpen = () => {
    if (isWaiting) {
      return <Waiting />;
    } else {
      if (isSessionOpen && !isLoggedIn) {
        let isPublicMode = queryParameters.get("public_mode");
        let isBoothMode = queryParameters.get("booth_mode");
        let songbookCode = queryParameters.get("songbook_code");
        if (isPublicMode === "") {
          isPublicMode = 1;
        }
        if (isBoothMode === "") {
          isBoothMode = 1;
        }
        var href = window.location.href;
        let hrefSplitted = href.split("?");
        if (hrefSplitted.length == 1) {
          let isPublicModeStorage = localStorage.getItem(muvikaAttrs.service + "-songbook-public-mode");
          if (isPublicModeStorage) {
            let isPublicModeBl = JSON.parse(isPublicModeStorage);
            if (isPublicModeBl) {
              isPublicMode = 1;
            }
          }
          let isBoothModeStorage = localStorage.getItem(muvikaAttrs.service + "-songbook-booth-mode");
          if (isBoothModeStorage) {
            let isBoothModeBl = JSON.parse(isBoothModeStorage);
            if (isBoothModeBl) {
              isBoothMode = 1;
            }
          }
          let earlierSongbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
          if (!songbookCode) {
            songbookCode = earlierSongbookCode;
          }
        }
        if ((isPublicMode == 1 || isBoothMode == 1) && songbookCode) {
          localStorage.setItem(muvikaAttrs.service + "-songbook-public-mode", isPublicMode == 1);
          localStorage.setItem(muvikaAttrs.service + "-songbook-booth-mode", isBoothMode == 1);
          localStorage.setItem(muvikaAttrs.service + "-songbook-songbook-code", songbookCode);
          console.log("songbookmodee", isPublicMode, isBoothMode, songbookCode);
          return renderPublicBoothMode(isPublicMode, isBoothMode, songbookCode);
        } else {
          //localStorage.setItem(muvikaAttrs.service+"-songbook-songbook-code", songbookCode);
          if (!isGettingCaptcha && !captchaId && !captchaData) {
            //createCaptcha();
          }
          console.log("captcha", captchaStore.getState().captchaData);
          return renderNormalMode(songbookCode);
        }
      } else {
        if (!isSessionOpening) {
          openSession(language.length > 0 ? language.toLowerCase() : "english");
        }
      }
    }
    setRendered(true);
  };

  const renderMain = () => {
    let songbookCode = queryParameters.get("songbook_code");
    let earlierSongbookCode = localStorage.getItem(muvikaAttrs.service + "-songbook-songbook-code");
    var href = window.location.href;
    let hrefSplitted = href.split("?");
    if (hrefSplitted.length == 1) {
      songbookCode = null;
    }
    console.log("songbook url", hrefSplitted.length, songbookCode);
    console.log("songbook", songbookCode, earlierSongbookCode, isSessionOpen, isLoggedIn, currentError ? currentError.code !== tooFewPrivileges && currentError.code !== sessionCloseErrorCode : true);
    if (isSessionOpen && isLoggedIn) {
      if (songbookCode) {
        if (songbookCode === earlierSongbookCode) {
          if (isLoginSeqError) {
            return <ThemeProvider theme={darkTheme}>
              <CssBaseline />
              <ErrorDialog
                open={errorDialogOpen}
                onClose={() => {
                  songbookSessionStore.getState().reset();
                  clearError();
                  window.location.reload(false);
                  localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
                  localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
                  localStorage.removeItem(muvikaAttrs.service + "-songbook-songbook-code");
                  handleDialogClose();
                }}
                title={TR.cm_error}
                message={TR.cm_failed_to_load_all_login_data}
                isRetryable={false}
              />
            </ThemeProvider>;
          } else {
            return <SongbookApp />;
          }
        } else {
          console.log("logoutChange");
          logoutChange(songbookCode, false, false);
        }
      } else {
        if (isLoginSeqError) {
          return <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <ErrorDialog
              open={errorDialogOpen}
              onClose={() => {
                songbookSessionStore.getState().reset();
                clearError();
                window.location.reload(false);
                localStorage.removeItem(muvikaAttrs.service + "-songbook-public-mode");
                localStorage.removeItem(muvikaAttrs.service + "-songbook-booth-mode");
                localStorage.removeItem(muvikaAttrs.service + "-songbook-songbook-code");
                handleDialogClose();
              }}
              title={TR.cm_error}
              message={TR.cm_failed_to_load_all_login_data}
              isRetryable={false}
            />
          </ThemeProvider>;
        } else {
          return <SongbookApp />;
        }
      }
    } else {
      return <ThemeProvider theme={darkTheme}>
        <Container component="main" maxWidth="xs" className="muvika-entry-container" onKeyDown={handleKeyDown}>
          <CssBaseline />
          <Error isSongbook={true} />
          <Message isSongbook={true} />
          {renderIfSessionOpen()}
        </Container>
      </ThemeProvider>;
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <div>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      {renderOverflowStyle()}
      {renderMain()}
    </div>
  );
}

export default SongbookLogin;